module.exports = __webpack_public_path__ + "static/media/table-with-fruit-and-coffeepot.d06c1905.jpg";